import isEmpty from 'lodash/isEmpty';
import Registry from '../registry/index';

import {
    ROOM_JOINED,
    ROOM_LEAVED,
    ROOM_DESTROYED,
    ROOM_TYPE_PRIVATE,
    VISIBLE_ROOM_SWITCHED,
    ROOM_STAYED, ROOM_USER_SORTING_UPDATED, VISIBLE_ROOM_CLOSED
} from '../constants/rooms';

import {PM_SESSION_START, PM_WINDOW_MAXIMIZE} from '../constants/pm';

import {LOGIN_SUCCESS} from '../constants/general';

import {
    ROOM_CLIENT_LOGOUT,
    USER_SORT_WATCHING,
    ROOM_CLIENT_UPDATE,
    USER_SORTING_SELECT
} from "../constants/users";

import {STREAM_WATCHING_ME} from "../constants/streaming";

function setCurrentRoomEditor(roomid) {
    let roomEditorInstanceName = 'roomEditorInstance__' + roomid;

    if (Registry.exists('roomEditorInstance_id')) {
        Registry.remove('roomEditorInstance_id');
    }

    Registry.add('roomEditorInstance_id', roomEditorInstanceName);
}

const roomsMiddleware = (store) => (next) => (action) => {
    //let ufrag;
    if (action.type === LOGIN_SUCCESS) {
        setCurrentRoomEditor(action.room.roomid);
    }

    if (action.type === ROOM_CLIENT_LOGOUT) {
        store.dispatch({type: ROOM_CLIENT_UPDATE, user: action.user, roomid: action.user.roomid});
    }

    if (action.type === VISIBLE_ROOM_SWITCHED) {
        let state = store.getState();

        if (!isEmpty(state.visibleChatrooms.all_roomids) && state.rooms.hasOwnProperty(state.visibleChatrooms.roomid) && !state.rooms[state.visibleChatrooms.roomid].stayed) {
            // store.dispatch({type: "LEAVE_ROOM_CMD", roomid: state.visibleChatrooms.roomid});
            let chatInterface = Registry.get('chatInterface');
            chatInterface.leaveRoom(state.visibleChatrooms.roomid, function() {});
        }

        if (action.room) {
            setCurrentRoomEditor(action.room.roomid);
        }

        next(action);

        store.dispatch({type: ROOM_USER_SORTING_UPDATED, sorting: state.userSorting});

        return;
    }

    if (action.type === ROOM_JOINED) {
        let roomid = action.roomid;
        let state = store.getState();
        let room = state.rooms[roomid];

        let chatInterface = Registry.get('chatInterface');

        // Switching to private room - close all others room
        if (room.info.type === ROOM_TYPE_PRIVATE) {
            for (let rid in state.rooms) {
                if (roomid === rid) continue;
                if (!state.rooms[rid].active) continue;

                chatInterface.leaveRoom(rid, function() {});
            }
            store.dispatch({type: ROOM_STAYED, roomid: roomid});
        }

        // Switching FROM private room - leave private, join selected
        if (room.info.type !== ROOM_TYPE_PRIVATE) {
            for (let rid in state.rooms) {
                if (roomid === rid) continue;
                if (!state.rooms[rid].active) continue;

                if (state.rooms[rid].info.type === ROOM_TYPE_PRIVATE) {
                    chatInterface.leaveRoom(rid, function() {});
                    store.dispatch({type: ROOM_STAYED, roomid: roomid});
                }
            }

            next(action);
            
            return;
        }
    }

    if (action.type === ROOM_LEAVED
        || action.type === ROOM_DESTROYED) {
        // Is it the last one room we are leaving? Join main room then.
        let roomid = action.roomid;
        let state = store.getState();
        //let room = state.rooms[roomid];

        for (let rid in state.rooms) {
            if (roomid === rid) continue;
            if (state.rooms[rid].active) {
                next(action);
                return;
            }
        }

        let chatInterface = Registry.get('chatInterface');

        let mainRoomId = chatInterface.getDefaultRoomId();
        let mainRoom = state.rooms[mainRoomId];

        if (mainRoom) {
            store.dispatch({type: VISIBLE_ROOM_SWITCHED, room: mainRoom});

            chatInterface.joinRoom(
                mainRoomId,
                '',
                function() {
                    store.dispatch({type: ROOM_STAYED, roomid: mainRoomId});
                    if (mainRoomId !== roomid) next(action);
                });

            return;
        }
        next(action);
        return;
    }

    if (action.type === USER_SORTING_SELECT) {

        store.dispatch({type: ROOM_USER_SORTING_UPDATED, sorting: action.sorting});

    }

    if (action.type === STREAM_WATCHING_ME) {
        next(action);
        if(store.getState().userSorting === USER_SORT_WATCHING) {
            store.dispatch({type: ROOM_USER_SORTING_UPDATED, sorting: USER_SORT_WATCHING});
        }
        return;
    }

    // if (action.type === PM_WINDOW_MAXIMIZE || action.type === PM_SESSION_START ) {
    //     const state = store.getState();
    //
    //     if (state.browser.mobile) {
    //         store.dispatch({type: VISIBLE_ROOM_CLOSED, roomid: state.currentRoom.id});
    //     }
    // }

    next(action);
};

export default roomsMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/rooms.js